// Причины полного стопа филиала. Зеркало бэкенд-enum App\Enums\FilialStopReason -
// независимый справочник от StopListReason (причин стопа отдельного блюда).
export default class FilialStopReason {
  static get StaffProblem () {
    return 'staff_problem'
  }

  static get NoPower () {
    return 'no_power'
  }

  static get NoWater () {
    return 'no_water'
  }

  static get EquipmentProblem () {
    return 'equipment_problem'
  }

  static get KitchenOverload () {
    return 'kitchen_overload'
  }

  static get Other () {
    return 'other'
  }

  static getName (enumValue) {
    switch (enumValue) {
      case FilialStopReason.StaffProblem:
        return 'Проблема с персоналом'

      case FilialStopReason.NoPower:
        return 'Нет света'

      case FilialStopReason.NoWater:
        return 'Нет воды'

      case FilialStopReason.EquipmentProblem:
        return 'Проблема с оборудованием'

      case FilialStopReason.KitchenOverload:
        return 'Перегруз кухни'

      case FilialStopReason.Other:
        return 'Другое'

      default:
        return enumValue
    }
  }

  static getAllVariants () {
    const variants = [
      FilialStopReason.StaffProblem,
      FilialStopReason.NoPower,
      FilialStopReason.NoWater,
      FilialStopReason.EquipmentProblem,
      FilialStopReason.KitchenOverload,
      FilialStopReason.Other,
    ]

    return variants.map(item => ({
      value: item,
      name: FilialStopReason.getName(item),
    }))
  }
}
